import { BarcodeReader } from "dynamsoft-javascript-barcode";
BarcodeReader.license = 'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAxNjQ3ODM2LVRYbFhaV0pRY205cVgyUmljZyIsIm9yZ2FuaXphdGlvbklEIjoiMTAxNjQ3ODM2IiwiY2hlY2tDb2RlIjotMTEwOTU5ODI3MX0=';
BarcodeReader.engineResourcePath = "https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@9.0.2/dist/";


// WEBPACK FOOTER //
// ./src/dbr.js